module.exports = __webpack_public_path__ + "static/15-4e28f03dd4da9d683ad279ac8a1cc03b.jpg";